import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterTextTag2 from "../FilterTextTag2";
import { cloneDeep, isArray, isString } from "lodash";
interface IFilterCRThuoc {
  loading?: boolean;
  setCondition: Dispatch<SetStateAction<any>>;
}

function FilterIDThuoc({ loading, setCondition }: IFilterCRThuoc) {
  const originFilter: { [key: string]: any } = {
    id: "",
    ten_moi_thau: "",
    ham_luong: "",
    bao_che: "",
    duong_dung: "",
    don_vi: "",
    nhom: "",
  };

  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  const handleSearchTags = (tags: any[] | string) => {
    const result: { [key: string]: any } = {};
    const andGroup = [];
    const orGroup = [];
    const notGroup = [];

    let regexAndOr = "";
    let regexNot = "";
    if (isArray(tags)) {
      if (tags?.length > 0) {
        // Phân loại các tag
        for (let i = 0; i < tags.length; i++) {
          const tag = tags[i];
          switch (tag.mode) {
            case "and":
              andGroup.push(tag.value.trim());
              break;
            case "or":
              orGroup.push(tag.value.trim());
              break;
            default:
              notGroup.push(tag.value.trim());
              break;
          }
        }
        if (andGroup?.length > 0 || orGroup?.length > 0) {
          // Nếu tag là loại and
          if (andGroup.length > 0) {
            regexAndOr += `${cloneDeep(andGroup).join(".*")}|${cloneDeep(
              andGroup
            )
              .reverse()
              .join(".*")}`;
          }
          // Nếu tag là loại or
          if (orGroup.length > 0) {
            regexAndOr += `${!!regexAndOr ? "|" : ""}${orGroup.join("|")}`;
          }
          result.$regex = regexAndOr;
          result.$options = "iu";
        }
        // Nếu tag là loại not
        if (notGroup.length > 0) {
          regexNot += `${notGroup.join("|")}`;
        }
        if (!!regexNot) {
          result.$not = {
            $regex: regexNot,
            $options: "iu",
          };
        }
        return result;
      } else {
        return null;
      }
    } else if (isString(tags)) {
      const regex = tags?.split(" ").join(".*");
      return {
        $regex: `^${regex}$`,
        $options: "iu",
      };
    } else {
      return null;
    }
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.id) {
      condition.id = filter.id;
    }
    if (filter.ten_moi_thau) {
      condition.ten_moi_thau = filter.ten_moi_thau;
    }
    if (filter.ham_luong) {
      condition.ham_luong = filter.ham_luong;
    }
    if (filter.bao_che) {
      condition.bao_che = filter.bao_che;
    }
    if (filter.duong_dung) {
      condition.duong_dung = filter.duong_dung;
    }
    if (filter.don_vi) {
      condition.don_vi = filter.don_vi;
    }
    if (filter.nhom) {
      condition.nhom = filter.nhom;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="ID (BV)"
        placeholder="Tìm theo ID"
        value={filter.id}
        onSearch={(val) => setFilter({ ...filter, id: val })}
      />
      <FilterTextTag2
        label="Tên mời thầu"
        placeholder="Tìm theo tên mời thầu"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, ten_moi_thau: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Hàm lượng"
        placeholder="Tìm theo hàm lượng"
        pending={loading}
        toggleClear={toggleClear}
        onSearch={(tags) => {
          setFilter({ ...filter, ham_luong: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Dạng bào chế"
        placeholder="Tìm theo dạng bào chế"
        pending={loading}
        toggleClear={toggleClear}
        onSearch={(tags) => {
          setFilter({ ...filter, bao_che: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Đường dùng"
        placeholder="Tìm theo đường dùng"
        pending={loading}
        toggleClear={toggleClear}
        onSearch={(tags) => {
          setFilter({ ...filter, duong_dung: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Đơn vị tính"
        placeholder="Tìm theo đơn vị tính"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, don_vi: handleSearchTags(tags) });
        }}
      />
      <FilterTextTag2
        label="Nhóm"
        placeholder="Tìm theo nhóm"
        toggleClear={toggleClear}
        pending={loading}
        onSearch={(tags) => {
          setFilter({ ...filter, nhom: handleSearchTags(tags) });
        }}
      />
    </WrapperFilter>
  );
}

export default FilterIDThuoc;
